import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));

// import { Router } from '@angular/router';

// --- DEBUG TEMPORAL: quitar una vez identificado el culpable ---
// const _navigate = Router.prototype.navigate;
// Router.prototype.navigate = function (commands: any[], extras?: any) {
//   console.group(
//     `%c[ROUTER] navigate() -> ${JSON.stringify(commands)}`,
//     'color: orange; font-weight: bold',
//   );
//   console.log('extras:', extras);
//   console.trace(); // <-- stack trace completo, click en cada línea te lleva al archivo/línea exacto
//   console.groupEnd();
//   return _navigate.apply(this, arguments as any);
// };

// const _navigateByUrl = Router.prototype.navigateByUrl;
// Router.prototype.navigateByUrl = function (url: any, extras?: any) {
//   console.group(
//     `%c[ROUTER] navigateByUrl() -> ${url}`,
//     'color: orange; font-weight: bold',
//   );
//   console.log('extras:', extras);
//   console.trace();
//   console.groupEnd();
//   return _navigateByUrl.apply(this, arguments as any);
// };
// --- FIN DEBUG TEMPORAL ---
